import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import { LocalStorage } from '~/helpers';
import OmniApplication from './lib/index';

import './lib/assets/scss/app.scss';

LocalStorage.removeOrigin();

ReactDOM.render(
  <OmniApplication isStandalone />,
  document.getElementById('root')
);
